import { ReactElement } from 'react';
import { Message, useMessage } from '@messageformat/react';
import { color, space } from '@op/opds.tokens';
import { Tile } from '@op/opds.opux';
import styles from './AcquisitionTile.module.scss';
import { getMsgValues } from '../../utils';
import { SectionContent, RowContent } from './TileSections';

interface AcquisitionTileProps {
  costArray: string[];
}

const AcquisitionTile = ({ costArray }: AcquisitionTileProps): ReactElement => {
  const labelArray = getMsgValues(useMessage('course9.stocks.acquisition.labels'));
  const calculations = getMsgValues(useMessage('course9.stocks.acquisition.calc'));
  const subTitleArray = getMsgValues(useMessage('course9.stocks.subtitles'));
  return (
    <Tile
      className={styles['tile-container']}
      style={{ marginTop: space.large, marginBottom: space.xl }}
    >
      <div className={styles['tile-content']}>
        <div className={styles['header-content']}>
          <h4 className="investoracademy-general-graph-title">
            <Message id="course9.stocks.acquisition.title" />
          </h4>
          <p className="investoracademy-text-paragraph" style={{ marginBottom: 0 }}>
            <Message id="course9.stocks.acquisition.intro" />
          </p>
        </div>
        <SectionContent subtitle={subTitleArray[0]}>
          <RowContent label={labelArray[0]} value={costArray[0]} />
          <RowContent label={labelArray[1]} value={costArray[1]} />
          <div className="investoracademy-divider-line" />
          <RowContent label={labelArray[2]} value={costArray[2]} />
        </SectionContent>
        <SectionContent subtitle={subTitleArray[1]}>
          <RowContent label={labelArray[3]} value={costArray[3]} />
        </SectionContent>
        <SectionContent subtitle={subTitleArray[3]}>
          <RowContent label={labelArray[4]} value={costArray[3]} />
          <RowContent label={labelArray[5]} value={costArray[2]} />
          <div className="investoracademy-divider-line" />
          <RowContent label={labelArray[6]} value={calculations[0]} />
          <RowContent
            label={labelArray[7]}
            value={costArray[4]}
            valueStyle={{ color: color.indicator.negative }}
          />
        </SectionContent>
        <SectionContent subtitle={subTitleArray[4]}>
          <RowContent label={labelArray[4]} value={costArray[3]} />
          <RowContent label={labelArray[8]} value={costArray[6]} />
          <div className="investoracademy-divider-line" />
          <RowContent label={labelArray[6]} value={calculations[1]} />
          <RowContent
            label={labelArray[7]}
            value={costArray[5]}
            valueStyle={{ color: color.indicator.negative }}
          />
        </SectionContent>
        <div className={styles['result-content']}>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.stocks.acquisition.body1" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.stocks.acquisition.body2" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.stocks.acquisition.body3" />

            <span className={styles.calculation}>{calculations[2]}</span>
            <Message id="course9.stocks.acquisition.body4" />

            <span className={styles.calculation}>{calculations[3]}</span>

            <Message id="course9.stocks.acquisition.body5" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.stocks.acquisition.body6" />
          </p>
          <p className="investoracademy-text-paragraph" style={{ paddingBottom: '0px' }}>
            <Message id="course9.stocks.acquisition.body3" />
            <span className={styles.calculation}>{calculations[4]}</span>

            <Message id="course9.stocks.acquisition.body7" />
          </p>
        </div>
      </div>
    </Tile>
  );
};

export default AcquisitionTile;
